"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SuburbanCallbackBanner = require("./SuburbanCallbackBanner");
Object.keys(_SuburbanCallbackBanner).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SuburbanCallbackBanner[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SuburbanCallbackBanner[key];
    }
  });
});